var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies, Layout } from '~/core/decorator';
import { PageService } from '~/utils/page.service';
import { SortService } from '~/utils/sort.service';
import NumberRange from '~/components/common/number-range.vue';
import { TelCaseManageService } from '~/services/domain-service/tel-case-manage.service';
import UserCaseAllot from '~/components/distribution-common/user-case-allot.vue';
import GetLabelName from "~/components/labeling-strategy/get-label-name.vue";
var TelWaitingCollectCaseManage = /** @class */ (function (_super) {
    __extends(TelWaitingCollectCaseManage, _super);
    function TelWaitingCollectCaseManage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            caseNumber: '',
            personalName: '',
            mobileNo: '',
            idCard: '',
            deptId: '',
            customerCategory: '',
            productCategory: '',
            productName: '',
            overdueAmount: {
                max: '',
                min: '',
            },
            overduePeriod: '',
            overdueDays: {
                max: '',
                min: '',
            },
            followInTime: [],
            area: '',
            labelName: []
        };
        _this.rules = {};
        _this.dataSet = [];
        _this.selectionList = [];
        _this.dialog = {
            ManualDivision: false,
        };
        return _this;
    }
    TelWaitingCollectCaseManage.prototype.created = function () {
        this.refreshData();
    };
    TelWaitingCollectCaseManage.prototype.refreshData = function () {
        var _this = this;
        this.telCaseManageService
            .waitDistribution(this.model, this.pageService, this.sortService)
            .subscribe(function (data) { return (_this.dataSet = data); });
    };
    TelWaitingCollectCaseManage.prototype.manualDivision = function () {
        if (this.selectionList.length === 0) {
            this.$message.info('请选择要分配的案件');
            return;
        }
        this.dialog.ManualDivision = true;
    };
    __decorate([
        Dependencies(PageService)
    ], TelWaitingCollectCaseManage.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], TelWaitingCollectCaseManage.prototype, "sortService", void 0);
    __decorate([
        Dependencies(TelCaseManageService)
    ], TelWaitingCollectCaseManage.prototype, "telCaseManageService", void 0);
    TelWaitingCollectCaseManage = __decorate([
        Layout('workspace'),
        Component({
            components: {
                GetLabelName: GetLabelName,
                NumberRange: NumberRange,
                UserCaseAllot: UserCaseAllot,
            },
        })
    ], TelWaitingCollectCaseManage);
    return TelWaitingCollectCaseManage;
}(Vue));
export default TelWaitingCollectCaseManage;
